export default "<h3>Permission Group Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"